import { useState } from "react";
import { Stack } from '@fluentui/react'
import Chat from "./Chat";
import styles from "./Chat.module.css";
import { useIsMobile } from "../../hooks/useIsMobile";

interface ChatWrapperProps {
  setShowModel: (show: boolean) => void;
  initialFullScreen?: boolean;
}

const ChatWrapper = ({setShowModel, initialFullScreen = false}: ChatWrapperProps) => {

  const isMobile = useIsMobile(900);

  const [fullScreen, setFullScreen] = useState(initialFullScreen);

  const closeChat = () => {
    setShowModel(false);
  }

  return (
    <Stack className={fullScreen ? styles.chatWrapper : styles.chatWrapperSmall}>
        {isMobile && <div className={styles.mobileBackground}/>}
        <Chat fullScreen={isMobile ? true : fullScreen} setFullScreen={setFullScreen} closeChat={closeChat} />
    </Stack>
  );
}

export default ChatWrapper;
